import { Text } from '@chakra-ui/react';


    function PreviewWidgetCard(props) {
     
     const { name, statistic, threshold, cardWidth, cardHeight, theme } = props;
     const value = 0;
     
     const cleanTitle = (unclean) => {
        let cleanSymbee;
        if(unclean.includes('_')){
         cleanSymbee = unclean;   
        } else {
            cleanSymbee = unclean[0] + unclean.slice(1).replace(/([A-Z])/g, '_$1');
        }
        const words = cleanSymbee.toLowerCase().split("_");
        for (let i = 0; i < words.length; i++) {
            words[i] = words[i][0].toUpperCase() + words[i].substr(1);
        }
        let result =  words.join(" ");
        return result;
    };
    
    const cleanValue = (unclean, metric) => {
        if(cleanTitle(metric) === 'Oldest Callback') {
            let date = new Date (value * 1000);
           let result = date.toLocaleTimeString("en-NZ", {hour: '2-digit', minute:'2-digit', hour12: false});
           return result;
        }
        else { return unclean }
        
    };

    const testThreshold = () => {
        if(threshold?.second?.operand && threshold?.second?.value) {
            if(threshold.second.operand === '>'){
                if(value > threshold.second.value) {
                    return 'second';
                }
            } else if(threshold.second.operand === '<') {
                if(value < threshold.second.value) {
                    return 'second';
                }
            }
        } 
        if(threshold?.first?.operand && threshold?.first?.value) {
            if(threshold.first.operand === '>'){
                if(value > threshold.first.value) {
                    return 'first';
                }
            } else if(threshold.first.operand === '<') {
                if(value < threshold.first.value) {
                    return 'first';
                }
            }
        }
        
        else return false;
    };
    
    const classes = {
        card: {
            borderRadius: '20px',
            boxShadow: '5px 5px 20px #b9b9b9, -5px -5px 20px #ffffff',
            color: testThreshold() === 'second' ? 'white' : testThreshold() === 'first' ? '#000' : theme.fontColor,
            background: testThreshold() === 'second' ? '#e11919' : testThreshold() === 'first' ? '#FFBF00' : theme.cardColor,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: cardWidth,
            height: cardHeight,
            overflow: 'hidden'
        },
    };
     
     
     return (
         
         <div style={classes.card}>
            <Text as='b' >{name}</Text>
            <Text fontSize='3xl' as='b'>{cleanValue(value, statistic)}</Text>
            <Text fontSize='sm' as='b'>{cleanTitle(statistic)}</Text>
         </div>
         
     );
    
}

export default PreviewWidgetCard;